import {
  useCallback, useRef,
} from 'react';
import { useDispatch } from 'react-redux';
import { notUndefined } from '~/_shared/utils/typeGuards';
import { useMapSettingsSettingsUnitSystemSelector } from '~/store/mapSettings/settings/mapSettingsSettings.selectors';
import { useClientIdSelector } from '~/store/selectors/useClientIdSelector';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';
import { userSetDirectionsApiUsage } from '~/store/userData/userData.actionCreators';
import {
  type DirectionsRequest, getDirectionsService,
} from './getDirections.service';

export const useFindDirections = () => {
  const dispatch = useDispatch();
  const clientId = useClientIdSelector();
  const mapId = useMapIdSelector();
  const unitSystem = useMapSettingsSettingsUnitSystemSelector();
  const getDirectionsServiceInstance = useRef(getDirectionsService(unitSystem));

  const findDirections = useCallback(async (requests: DirectionsRequest) => {
    if (clientId === null || mapId === null) {
      return Promise.reject('Client ID or Map ID is null');
    }

    const {
      results,
      newDirectionsRequestsUsage,
    } = await getDirectionsServiceInstance.current.findDirections(mapId, clientId, requests);

    if (notUndefined(newDirectionsRequestsUsage)) {
      dispatch(userSetDirectionsApiUsage(newDirectionsRequestsUsage));
    }

    return results;
  }, [clientId, dispatch, mapId]);

  return {
    findDirections,
  };
};
